if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js", {
      scope: "/",
      updateViaCache: "none"
    }).catch(() => {
      // Service worker registration is progressive enhancement; HTML remains the baseline.
    })
  })
}
